import { armarParametros } from "../helpers/armarParametros";
import { fetchConToken } from "../helpers/fetch";

const totemService = {
    getOpciones: () => fetchConToken(`Totem/Opciones`),
    insertOpcion: (data) => fetchConToken(`Totem/Opciones`, data, "POST"),
    updateOpcion: (data) => fetchConToken(`Totem/Opciones`, data, "PUT"),
    deleteOpcion: (data) => fetchConToken(`Totem/Opciones`, data, "DELETE"),

    getSubOpciones: () => fetchConToken(`Totem/SubOpciones`),
    insertSubOpcion: (data) => fetchConToken(`Totem/SubOpciones`, data, "POST"),
    updateSubOpcion: (data) => fetchConToken(`Totem/SubOpciones`, data, "PUT"),
    deleteSubOpcion: (data) => fetchConToken(`Totem/SubOpciones`, data, "DELETE"),

    getRecepciones: () => fetchConToken(`Totem/Recepciones`),
    insertRecepcion: (data) => fetchConToken(`Totem/Recepciones`, data, "POST"),
    updateRecepcion: (data) => fetchConToken(`Totem/Recepciones`, data, "PUT"),
    deleteRecepcion: (data) => fetchConToken(`Totem/Recepciones`, data, "DELETE"),

    getRecepcionesUsuario: () => fetchConToken(`Totem/Recepciones/Usuario`),

    getByIdSolicitudesRecepcionesUsuario: () => fetchConToken(`TotemRecepcionistas/SolicitudesUsuario`),
    insertSolicitudRecepcionUsuario: (data) => fetchConToken(`TotemRecepcionistas/SolicitudUsuario`, data, 'POST'),
    confirmSolicitudRecepcionUsuario: (data) => fetchConToken(`TotemRecepcionistas/SolicitudUsuario/Confirm`, data, 'PUT'),
    rejectSolicitudRecepcionUsuario: (data) => fetchConToken(`TotemRecepcionistas/SolicitudUsuario/Reject`, data, 'DELETE'),

    getSolicitudesAfiliados: (parameters) => fetchConToken(`TotemRecepcionistas/SolicitudAfiliado/Search${armarParametros(parameters)}`),
    insertSolicitudAfiliado: (data) => fetchConToken(`TotemRecepcionistas/SolicitudAfiliado`, data, 'POST'),
    insertSolicitudAfiliadoRecepcionista: (data) => fetchConToken(`TotemRecepcionistas/SolicitudAfiliado/Recepcionista`, data, 'POST'),
    confirmSolicitudAfiliado: (data) => fetchConToken(`TotemRecepcionistas/SolicitudAfiliado/Confirm`, data, 'PUT'),

    getAfiliado: (parameters) => fetchConToken(`TotemRecepcionistas/Afiliado/Parameters${armarParametros(parameters)}`),
    getTurnosAfiliados: (idAfiliado) => fetchConToken(`TotemRecepcionistas/Afiliado/Turnos/${idAfiliado}`),
    confirmTurnoAfiliado: (data) => fetchConToken(`TotemRecepcionistas/Afiliado/Turnos/Confirm`, data, 'POST'),

    getSolicitudesAfiliadosFiles: (parameters) => fetchConToken(`TotemFiles/SolicitudesAfiliados/Search${armarParametros(parameters)}`),
    excelSolicitudesAfiliadosFiles: (parameters) => fetchConToken(`TotemFiles/SolicitudesAfiliados/Excel${armarParametros(parameters)}`),
    pdfSolicitudesAfiliadosFiles: (parameters) => fetchConToken(`TotemFiles/SolicitudesAfiliados/Pdf${armarParametros(parameters)}`),

    getRecepcionesPisos: () => fetchConToken(`Totem/RecepcionesPiso`),
    insertRecepcionPiso: (data) => fetchConToken(`Totem/RecepcionesPiso`, data, "POST"),
    updateRecepcionPiso: (data) => fetchConToken(`Totem/RecepcionesPiso`, data, "PUT"),
};

export default totemService;